/**
 * Premium Upgrade Success Page
 */
import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Crown, CheckCircle2, Gift, Loader2, Home, User } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import api from '../../services/api';

const PremiumSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');
  
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const loadOrder = async () => {
      if (!orderId) {
        setLoading(false);
        return;
      }
      
      try {
        const response = await api.get(`/shop/order/${orderId}`);
        setOrder(response.data);
      } catch (err) {
        console.error('Error loading order:', err);
      } finally {
        setLoading(false);
      }
    };
    
    loadOrder();
  }, [orderId]);
  
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#7ED957]" />
      </div>
    );
  }
  
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <Card className="bg-gradient-to-br from-yellow-500/20 to-orange-500/10 border-yellow-500/50 max-w-md w-full">
        <CardHeader className="text-center pb-2">
          <div className="mx-auto mb-4 w-20 h-20 bg-yellow-500/20 rounded-full flex items-center justify-center">
            <Crown className="w-12 h-12 text-yellow-500" />
          </div>
          <CardTitle className="text-2xl text-white">¡Bienvenido a Premium!</CardTitle>
          <CardDescription className="text-gray-300">
            Tu suscripción ha sido activada exitosamente
          </CardDescription>
        </CardHeader>
        
        <CardContent className="space-y-6">
          <div className="bg-gray-800/50 rounded-lg p-4 space-y-3">
            <div className="flex items-center gap-2 text-[#7ED957]">
              <CheckCircle2 className="w-5 h-5" />
              <span className="font-medium">Premium activo por 6 meses</span>
            </div>
            
            {order?.includes_free_shelly && (
              <div className="flex items-center gap-2 text-[#7ED957]">
                <Gift className="w-5 h-5" />
                <span className="font-medium">Botón Shelly gratis en camino</span>
              </div>
            )}
          </div>
          
          {order?.includes_free_shelly && order?.shipping_address && (
            <div className="text-center text-gray-400 text-sm">
              <p>Tu botón Shelly será enviado a:</p>
              <p className="text-white mt-1">
                {order.shipping_address.street_name} {order.shipping_address.street_number}
                {order.shipping_address.apartment && `, ${order.shipping_address.apartment}`}
              </p>
              <p className="text-white">
                {order.shipping_address.city}, {order.shipping_address.state} {order.shipping_address.zip_code}
              </p>
            </div>
          )}
          
          <div className="flex flex-col gap-3">
            <Button
              onClick={() => navigate('/profile')}
              className="w-full bg-yellow-500 hover:bg-yellow-600 text-black font-bold"
            >
              <User className="w-4 h-4 mr-2" />
              Ver mi perfil Premium
            </Button>
            <Button
              onClick={() => navigate('/home')}
              variant="outline"
              className="w-full border-gray-600 text-gray-300 hover:bg-gray-700"
            >
              <Home className="w-4 h-4 mr-2" />
              Ir al inicio
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PremiumSuccess;
